let title = ' | Gestor - Comercial Ivaiporã'

const wolihub = {
    path: '/wolihub',
    component: () => import('@/Components/Wolihub/WolihubContainer'),
    children: [
        {
            path: '',
            name: 'WolihubInicio',
            component: () => import('@/Components/Wolihub/WolihubInicio'),
            meta: {
                title: 'WoliHub' + title,
                permission: 'wolihub_menu',
                breadcrumb: [
                    { text: 'Início',  exact: true, link: true, disabled: false, to: '/' },
                    { text: 'WoliHub', exact: true, link: true, disabled: true,  to: '' },
                ]
            }
        },
        {
            path: 'dashboard',
            name: 'WolihubDashboard',
            component: () => import('@/Components/Wolihub/WolihubDashboard'),
            meta: {
                title: 'WoliHub - Dashboard' + title,
                permission: 'wolihub_dashboard',
                breadcrumb: [
                    { text: 'Início',     exact: true, link: true, disabled: false, to: '/' },
                    { text: 'WoliHub',    exact: true, link: true, disabled: false, to: '/wolihub' },
                    { text: 'Dashboard',  exact: true, link: true, disabled: true,  to: '' },
                ]
            }
        },
        {
            path: 'vendas',
            name: 'WolihubVendas',
            component: () => import('@/Components/Wolihub/WolihubVendas'),
            meta: {
                title: 'WoliHub - Vendas' + title,
                permission: 'wolihub_remover_ebook',
                breadcrumb: [
                    { text: 'Início',   exact: true, link: true, disabled: false, to: '/' },
                    { text: 'WoliHub', exact: true, link: true, disabled: false, to: '/wolihub' },
                    { text: 'Vendas', exact: true, link: true, disabled: true,  to: '' },
                ]
            }
        },
        {
            path: 'auditoria',
            name: 'WolihubAuditoria',
            component: () => import('@/Components/Wolihub/WolihubAuditoria'),
            meta: {
                title: 'WoliHub - Auditoria' + title,
                permission: 'wolihub_auditoria',
                breadcrumb: [
                    { text: 'Início',    exact: true, link: true, disabled: false, to: '/' },
                    { text: 'WoliHub',   exact: true, link: true, disabled: false, to: '/wolihub' },
                    { text: 'Auditoria', exact: true, link: true, disabled: true,  to: '' },
                ]
            }
        },
    ]
}

export default wolihub
